import type { ReactNode } from 'react';
import { MultiTariffUpsaleRadioType } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';
import { MultiTariffUpsaleModelBase } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialogBase.model';
import { economy } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/useYearSavingWithDiscountPeriod';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { formatPrice } from 'reactApp/utils/priceHelpers';

export class MultiTariffUpsaleModel extends MultiTariffUpsaleModelBase {
    private isAdvancedMonth = this.activeTab === ETabsName.advanced && this.isMonthActivePeriod();
    override getTitle(): ReactNode {
        if (this.isAdvancedMonth) {
            return 'Платить за\u00A0год выгоднее';
        }
        return 'Основной тариф выгоднее, чем\u00A0Минимальный';
    }

    override getTitleDescription(): ReactNode {
        if (this.isAdvancedMonth) {
            return `Вы\u00A0выбрали тариф ${this.product.space.value} на\u00A0месяц\u00A0— а\u00A0если взять на\u00A0год, то\u00A0можно сэкономить`;
        }
        return 'В\u00A0нём\u00A0больше возможностей. Например, нейросеть в\u00A0Облаке поможет удалить дубли фото. И\u00A0реклама пропадёт, в\u00A0Почте тоже';
    }

    override getPriorityCardTopTitle(): ReactNode {
        if (this.isAdvancedMonth) {
            return 'На\u00A0год';
        }
        return `+${this.product.space.value}`;
    }

    override getPriorityCardLabelText(): ReactNode {
        const upsaleProduct = this.getUpsaleProduct();
        if (this.isAdvancedMonth && upsaleProduct) {
            return `Экономия ${formatPrice(economy(this.product, upsaleProduct), 'ru')} ₽`;
        }
        return '+ 10 возможностей';
    }

    override getSecondaryCardTopTitle(): ReactNode {
        if (this.isAdvancedMonth) {
            return 'На\u00A0месяц';
        }
        return `+${this.product.space.value}`;
    }

    override getSecondaryCardLabelVisible(): boolean {
        return !this.isAdvancedMonth;
    }

    override getSecondaryCardLabelText(): ReactNode {
        if (this.isAdvancedMonth) {
            return '';
        }
        return 'Только место';
    }

    override getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        const isPriority = selected === MultiTariffUpsaleRadioType.priority;
        return {
            ...dwh,
            name: this.isAdvancedMonth ? 'period' : 'tariff_line',
            selectedPeriod: (this.isAdvancedMonth && isPriority) || this.isYearActivePeriod() ? 'year' : 'month',
            selected_tariff_line: this.isAdvancedMonth || isPriority ? 'advanced' : 'basic',
        };
    }
}
